module.exports = __webpack_public_path__ + "img/USAIDLogo.b0d152b5.png";